// extracted by mini-css-extract-plugin
module.exports = {"logo":"Navbar_logo__xbLVn","burger":"Navbar_burger__4k3ro","getInTouch":"Navbar_getInTouch__wqV3z"};